/**
 * Mensagem de feedback (sucesso ou erro) usada nos formulários.
 * `role` correto para leitores de tela: alert interrompe, status não.
 */
export function Feedback({ kind, children }: { kind: 'success' | 'error'; children: string }) {
  return (
    <p className={`feedback feedback--${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      {children}
    </p>
  );
}
